import React from 'react';
import {
  Box,
  Button,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  TextField,
  Typography
} from '@mui/material';

import styles from '../../../style';

const vitalSigns = [
  {
    label: 'BP',
    value: '121/64'
  },
  {
    label: 'Temp',
    value: '98.9'
  },
  {
    label: 'HR',
    value: '64'
  },
  {
    label: 'RR',
    value: '---'
  },
  {
    label: 'WT',
    value: '130'
  },
  {
    label: 'HT',
    value: '178'
  }
];

const soapSections = [
  {
    label: 'Subjective',
    value:
      'Outlined text fields have less visual emphasis than filled text fields. When they appear in places like forms.'
  },
  {
    label: 'Objective',
    value:
      'Outlined text fields have less visual emphasis than filled text fields. When they appear in places like forms.'
  },
  {
    label: 'Assessment Plan',
    value:
      'Outlined text fields have less visual emphasis than filled text fields. When they appear in places like forms.'
  }
];

const medications = [
  {
    direction: 'PRN Anxiety',
    dose: '0.5 MG',
    medication: 'Alprazolam PRN Anxiety',
    quantity: '15',
    refill: '1'
  },
  {
    direction: 'in PM',
    dose: '10 ML',
    medication: 'Childrens Benadryl',
    quantity: '25',
    refill: '12'
  }
];

const SoapEntry = () => {
  return (
    <Box
      sx={[
        styles.soapEntryWrap,
        styles.soapViewWrap
      ]}
    >
      <Box
        sx={[
          styles.soapEntryItem,
          styles.soapEntryTitle
        ]}
      >
        <Box
          sx={{
            alignItems: 'center',
            display: 'flex',
            gap: 2,
            justifyContent: 'space-between',
            whiteSpace: 'nowrap'
          }}
        >
          <Typography sx={{ fontWeight: 700 }}>
            Smith, John
          </Typography>

          <Typography sx={{ fontWeight: 700 }}>
            03/07/1987 (32 Yr)
          </Typography>

          <Box
            sx={{
              display: 'flex',
              gap: 0.5
            }}
          >
            <Button
              color="primary"
              size="small"
              variant="outlined"
            >
              SOAP
            </Button>

            <Button
              color="primary"
              size="small"
              variant="outlined"
            >
              H &amp; P
            </Button>
          </Box>
        </Box>
      </Box>

      <Box sx={styles.soapEntryItem}>
        <Box sx={styles.vitalBody}>
          <Typography sx={{ fontWeight: 600 }}>
            VS
          </Typography>

          {vitalSigns.map(item => (
            <TextField
              defaultValue={item.value}
              key={item.label}
              label={item.label}
              size="small"
              slotProps={{
                inputLabel: {
                  shrink: true
                }
              }}
              sx={styles.textField}
              variant="outlined"
            />
          ))}

          <TextField
            defaultValue="BMI: 20"
            size="small"
            sx={[
              styles.textField,
              styles.highlight,
              {
                '& .MuiOutlinedInput-root': {
                  backgroundColor: '#FF0000',
                  color: '#FFFFFF'
                }
              }
            ]}
            variant="outlined"
          />
        </Box>
      </Box>

      {soapSections.map(section => (
        <Box
          key={section.label}
          sx={styles.soapEntryItem}
        >
          <TextField
            defaultValue={section.value}
            fullWidth
            label={section.label}
            multiline
            minRows={3}
            slotProps={{
              inputLabel: {
                shrink: true
              }
            }}
            sx={styles.textField}
            variant="outlined"
          />
        </Box>
      ))}

      <Box sx={styles.soapEntryItem}>
        <Typography
          sx={{
            backgroundColor: '#3397F3',
            color: '#FFFFFF',
            fontWeight: 500,
            p: 0.625
          }}
        >
          Rx
        </Typography>

        <Table
          sx={[
            styles.templateTable,
            {
              border: '1px solid #3397F3',
              borderCollapse: 'separate'
            }
          ]}
        >
          <TableHead>
            <TableRow>
              <TableCell sx={{ width: '25%' }}>
                Medication
              </TableCell>
              <TableCell>Dose</TableCell>
              <TableCell sx={{ width: '25%' }}>
                Direction
              </TableCell>
              <TableCell>Quantity</TableCell>
              <TableCell>Refill</TableCell>
            </TableRow>
          </TableHead>

          <TableBody>
            {medications.map(medication => (
              <TableRow key={medication.medication}>
                <TableCell>{medication.medication}</TableCell>
                <TableCell>{medication.dose}</TableCell>
                <TableCell>{medication.direction}</TableCell>
                <TableCell>{medication.quantity}</TableCell>
                <TableCell>{medication.refill}</TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </Box>
    </Box>
  );
};

export default SoapEntry;